import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=328c70ff&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.scss?vue&type=style&index=0&id=328c70ff&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c70ff",
  null
  
)

export default component.exports